/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useMemo} from "react";
import {useFormatValue} from "../../../Hooks/FormatterHooks";
import {EmptyValue} from "../../../Components/Common/EmptyValue";

export const NumberFieldViewer = (props) => {
	const {
		FieldDef = {}
	} = props;
	
	const {
		customData = {},
		formatter
	} = FieldDef;
	
	const mergedProps = {
		...customData,
		...props
	}
	const { Value:value, isPrefix, suffix, className } = mergedProps;
	
	const formatValue = useFormatValue(formatter?.name, formatter?.params)
	const formattedValue = useMemo(() => formatValue(value), [formatValue, value]);
	
	if((value ?? '') === '') {
		return <EmptyValue/>;
	}
	
	return <div className={className}>
		{isPrefix && value != null ? suffix : ""} {formattedValue} {!isPrefix && value != null ? suffix : ""}
	</div>;
};
